import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import Unidadetransporte from '../componentes/unidadetransporte';
import TipoVeiculo from '../componentes/componetetipoveiculo';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));


      //****************************controle atalho cadastrar***************************** */
   
  

 
      
  var novo=false;
  var unid;
 
  
  var tipov1;
export default function RecipeReviewCard(props) {
  const [unidadetransporte, setaunidadetransporte] = React.useState([{
    id:'', label:''
  }]);

  const[tipoveiculo,setatipoveiculo]=React.useState('');
  const[tipov,setatipov]=React.useState('');
  const[unidadet,setaunidadet]=React.useState('');
  const [itemveiculo, setitemveiculo] = React.useState([]);
  const [statecampi,setcampi]=React.useState('');
  const [edita, setedita] = React.useState(true);
  const [modelo, setamodelo]=React.useState('');
  const [placa, setaplaca]=React.useState('');
  const [marca, setamarca]=React.useState('');
  const [kilometro, setakilometro]=React.useState('');
  const [capacidade, setacapacidade]=React.useState('');
  const [passageiro, setapassageiro]=React.useState('');
  const [ano, setaano]=React.useState('');
  const [stid, setaid]=React.useState('');

//*******************************salvar edit************ */

const handlesalvar=()=>{
    
  var model = modelo;
  var plac = placa;
  var marc = marca;
  var km = kilometro;
  var codtipoveiculo=tipoveiculo[0].id;
  var cap = capacidade;
  var passag=passageiro;
  var an = ano;
  var codunidadetransporte = unidadetransporte[0].id;
  var userid;
  itemveiculo.forEach(modelo=>(userid=modelo.id));

  console.log("cadastrou o modelo", modelo);
  console.log("cadastrou o placa", placa)
  console.log("cadastrou o km", kilometro)
  console.log("cadastrou o cod tipo",codtipoveiculo);
  console.log("cadastrou o pass",passag);
  console.log("cadastrou o ano",ano);
  console.log("cadastrou o cod unidade",codunidadetransporte);
  console.log("cadastrou o marca",marca);
  console.log("cadastrou o capc",capacidade);
  console.log("cadastrou o id",userid);
 
    if(novo){
      var db = firebase.firestore();
    var docRef = db.collection("veiculos").doc();
    var cid = docRef.id;
    
    docRef.set({ codunidadetransporte: codunidadetransporte,
                  modelo: model, placa: plac, km: km, ano: an, marca: marc,
                  codtipoveiculo: codtipoveiculo, capacidadecarga: cap, 
                  npassageiros: passag, status:true
                  
                }).then(function () {
                  alert("Cadastro Realizado");
                  setedita(true);
                  setbotaoedit(false);
                  setExpanded(false);
                  console.log("cadastrou o veiculo")
                  var query = firebase.firestore().collection("veiculos").doc(cid).get()
                  .then((doc) => {
                    var listaveiculos1=[];
                      listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
                        placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km,
                      marca: doc.data().marca, codunidadetransporte: doc.data().codunidadetransporte, status: doc.data().status,
                    codtipoveiculo: doc.data().codtipoveiculo ,npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga, novo:false});
                    //console.log("veiculos pqp ", state );
                    setitemveiculo (listaveiculos1);
                   
        
                  
                 
                })
               .catch(error => {
                   console.log('Não encontramos veículos cadastrados', error);
               });

              }).catch(function (error) {
                    var errorMessage = error.message;
          
                  alert(errorMessage);
                  })
    }else{

      var db = firebase.firestore();
      var docRef = db.collection("veiculos").doc(userid);
      
  
     return docRef.update({codunidadetransporte: codunidadetransporte, modelo: modelo, placa: placa,
        codtipoveiculo: codtipoveiculo, km: km, ano: an, marca: marc, capacidadecarga:
          cap, npassageiros: passag})
          .then(function () {
            alert("Atualizado com Sucesso");
                  setedita(true);
                  setbotaoedit(false);
                  setExpanded(false);
      
                  var query = firebase.firestore().collection("veiculos").doc(userid).get()
                  .then((doc) => {
                    var listaveiculos1=[];
                      listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
                        placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km,novo:false,
                      marca: doc.data().marca, codunidadetransporte: doc.data().codunidadetransporte, status: doc.data().status,
                    codtipoveiculo: doc.data().codtipoveiculo ,npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga});
                    //console.log("veiculos pqp ", state );
                    setitemveiculo (listaveiculos1);
                   
        
                  
                 
                })
               .catch(error => {
                   console.log('Não encontramos veículos cadastrados', error);
               });
    
              }).catch(function (error) {
                    var errorMessage = error.message;
          console.log(errorMessage);
                  alert(errorMessage);
                  })
                
    
    
    }

 


}

//********************objeto veiculo******************* */



React.useEffect(() => {
  setitemveiculo(props.props);
  console.log('props item vei item novo= ' , props.props);
  setcampi(props.campi);
 
  console.log('props campi ' , props.campi);
},[props])


React.useEffect(() => {
  var st=true;
  
  itemveiculo.forEach(modelo=>(novo=modelo.novo));
 console.log('props item vei item novo aqui= ' , novo);
   
  if (novo) {
   // console.log('props item vei item novo= ' , novo);
   itemveiculo.forEach(modelo=>(unid=modelo.codunidadetransporte));
   console.log('valor da unidade ' , unid);
   setaunidadet(unid);
    handleeditar();
  } else {
    
  
    
  
  itemveiculo.forEach(modelo=>(unid=modelo.codunidadetransporte));
  console.log('valor da unidade ' , unid);
  setaunidadet(unid);

  var model;
  itemveiculo.forEach(modelo=>(model=modelo.modelo));
  setamodelo(model);
  var placa;
  itemveiculo.forEach(modelo=>(placa=modelo.placa));
  setaplaca(placa);
  var marca;
  itemveiculo.forEach(modelo=>(marca=modelo.marca));
  setamarca(marca);
  var kilometro;
  itemveiculo.forEach(modelo=>(kilometro=modelo.km));
  setakilometro(kilometro);
  var capacidade;
  itemveiculo.forEach(modelo=>(capacidade=modelo.capcarga));
  setacapacidade(capacidade);
  var passageiro;
  itemveiculo.forEach(modelo=>(passageiro=modelo.npassageiros));
  setapassageiro(passageiro);
  var ano;
  itemveiculo.forEach(modelo=>(ano=modelo.anofab));
  setaano(ano);


 // pegaunidadetransporte(unid);
  
  itemveiculo.forEach(modelo=>(tipov1=modelo.codtipoveiculo));
  setatipov(tipov1);
  //tipoveiculo[0].id=tipov1;
  
  
  itemveiculo.forEach(modelo=>(st=modelo.status))
 
  
    setState({...state,checkmanobra:st})
   
  
  }

 /* async function pegaunidadetransporte(cod){
    
    var campis='';
   console.log("valor cod", cod);
    var ut = firebase.firestore().collection("unidadetransporte").doc(cod);
     await ut.get()
      .then((doc) => {       
        if (doc.exists) {
          tipounidade=[];
            tipounidade.push({id: doc.id, label: doc.data().nomeunidadetransporte});
            //campis = doc.data().campi;
          }
          setaunidadetransporte(tipounidade);
          console.log("saporra ", tipounidade)
         
      })
      .catch(function(error) {
          console.log("Erro ao carregar (unidades transporte): ", error);
      });
  }

  /*async function pegatipoveiculo(cod){
    
    var ut = firebase.firestore().collection("tiposveiculo").doc(cod);
      ut.get()
      .then((doc) => {       
        if (doc.exists) {
          tipoveiculo1=[];
            tipoveiculo1.push({id: doc.id, label: doc.data().tipoveiculo});
          }
          setatipoveiculo(tipoveiculo1);
      })
      .catch(function(error) {
          console.log("Erro ao carregar (tipos de veículos): ", error);
      });
  }*/
  


},[itemveiculo,edita]);





     
  //**************************controle habilita e desabilita */

  
  const [botaoedit, setbotaoedit] = React.useState(false);

  const handleeditar=()=>{
    setedita(false);
    setbotaoedit(true);
    setExpanded(true);
    
  }



     //************************************controle interruptor*/
     
  
  const [state, setState] = React.useState({
    checkmanobra:false,});

  const handlemanobra = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });

    //console.log('val state ', event.target.checked)
    var userid;
    itemveiculo.forEach(modelo=>(userid=modelo.id));
    //console.log("valor do id ", itemveiculo )
    
    if (userid) {
      var user = firebase.firestore().collection("veiculos").doc(userid);
    
    return user.update({status:event.target.checked})
    .then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
    }
    
  };
 
//****************************************valor autocomplete****************************** */

      
//********************controle expansão card*********************************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    setedita(true);
    setbotaoedit(false)}
  };

  const handleClickAway = () => {
    setExpanded(false);
    setedita(true);
    setbotaoedit(false)
  };



  //*******************************interface************************************************** */
  
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div id="card">
    <Card id={props.value} className={classes.root} >
       
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             
             title=  {placa}
             subheader=  {modelo}
     
           />
                    
            <CardActions disableSpacing>
           
            <FormGroup row>
            <FormControlLabel
             control={
               <Switch
                 checked={state.checkmanobra}
                 onChange={handlemanobra}
                 name="checkmanobra"
                 color="primary"
               />
             }
             label="Ativo"
           />
           
         </FormGroup>
     
             <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}> 
               <SaveIcon />
             </IconButton>
             <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
               <CreateIcon />
             </IconButton>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
            
             {console.log("valor do campi  card veiculo antes do carrega unidade1 transporte", unidadetransporte)}
             {console.log("valor do campi  card veiculo antes do carrega unidade transporte", props.campi)}
             <Unidadetransporte requer={true} key={props.id} id={"listaunidadest"}
        campi={props.campi}  disabled={edita} unidadet={unidadet} setaunidadetransporte={setaunidadetransporte} />

         
     
         
          <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setamodelo(e.target.value)}
              required
              type="nome"
              fullWidth
              id={"modelo"+props.value}
              label="Modelo do veículo"
              name="modelo"
              defaultValue={modelo}
              disabled={edita}
              
            />
     
     
                     <TextField
                      
                      variant="outlined"
                      margin="normal"
                      onChange={ e=>setaplaca(e.target.value)}
                      required
                      type="phoneNumber"
                      fullWidth
                      id={"placa"+props.value}
                      label="Placa do Veículo"
                      name="placa"
                      defaultValue={placa}
                      disabled={edita}
                      
                      />   
                
                <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setaano(e.target.value)}
              required
              type="Number"
              fullWidth
              id={"ano"+props.value}
              label="Ano"
              name="ano"
              defaultValue={ano}
              disabled={edita}
              
              
            />             
                
                <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setakilometro(e.target.value)}
              required
              type="Number"
              fullWidth
              id={"km"+props.value}
              label="Km"
              name="km"
              defaultValue = {kilometro}
              disabled={edita}
              />
                 
     
            <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setamarca(e.target.value)}
              required
              type=""
              fullWidth
              id={"marca"+props.value}
              label="Marca do Veiculo"
              name="marca"
              defaultValue=  {marca}
                 disabled={edita}
            />
     
                 
                     {console.log("tipo veiculo antes do componente1", tipov)} 
     <TipoVeiculo requer={true} id={"listatiposv"} key={itemveiculo.map(modelo=>(modelo.placa))}
          disabled={edita} cod={tipov} props={tipoveiculo} setatipoveiculo={setatipoveiculo} />

   
     
            <TextField
              variant="outlined"
              margin="normal"
              onChange={ e=>setacapacidade(e.target.value)}
              required
              type="Number"
              fullWidth
              id={"capcarga"+props.value}
              label="Capacidade de Carga"
              name="capcarga"
              defaultValue=  {capacidade}
              disabled={edita}
              
              
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              onChange={ e=>setapassageiro(e.target.value)}
              name="passageiros"
              label="Numero de Passageiros (com motoristas)"
              type="Number"
              id={"passageiros"+props.value}
              defaultValue={passageiro}
              disabled={edita}
            />
     
              
             <Typography component="h7" variant="h10">
           * Preenchimento obrigatório 
          </Typography>
     
          
        
                             
          
     
             </CardContent>
             <CardActions disableSpacing>
           
                
             <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}> 
               <SaveIcon />
             </IconButton>
             <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
               <CreateIcon />
             </IconButton>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
           
         </Card>
         </div>
         </ClickAwayListener>
        
  );
}

/*
<form className={classes.form} onSubmit={handlesalvar} noValidate={false}>
           </form>
           type="submit" >
*/